import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { EntityItem, HistoryLog } from '@helpers/types/models';

@Component({
	selector: 'app-history-logs-changes',
	standalone: false,
	templateUrl: './history-logs-changes.component.html',
	styleUrl: './history-logs-changes.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class HistoryLogsChangesComponent {

	logs!: HistoryLog[];

	constructor(
		private readonly dialogRef: DialogRef<boolean>,
		@Inject(DIALOG_DATA) readonly data: HistoryLog[]
	) {
		this.logs = data;
	}

	close(): void {
		this.dialogRef.close(false);
	}

	isEmpty(obj: any): boolean {
		return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
	}

	getDifferences(objOld: any, objNew: any): string[] {
		const diffs: string[] = [];
		const allKeys = new Set([
			...Object.keys(objOld || {}),
			...Object.keys(objNew || {})
		]);
		allKeys.forEach(key => {
			const oldVal = objOld ? objOld[key] : undefined;
			const newVal = objNew ? objNew[key] : undefined;
			if (JSON.stringify(oldVal) !== JSON.stringify(newVal)) {
				diffs.push(key);
			}
		});
		return diffs;
	}

	getStyledEntity(entity: { [key: string]: any } | undefined, diffs: string[]): EntityItem[] {
		const result: EntityItem[] = [];
		if (entity) {
			Object.keys(entity).forEach(key => {
				const val = entity[key];
				const displayValue = (val !== null && typeof val === 'object') ? JSON.stringify(val) : val;
				result.push({
					key,
					value: displayValue,
					highlight: diffs.includes(key)
				});
			});
		}
		return result;
	}

	protected readonly JSON = JSON;
}
